const UTILITY_ANCHOR_KEY = "utility-contact";

const UTILITY_LOAD_CALCULATOR_URL =
  "https://docs.google.com/spreadsheets/d/1gnzwdVhSnCjWmVO0GCz9JNszkS-vWtzXRIeLgTRyt34/edit?gid=2071810198#gid=2071810198";

export { UTILITY_ANCHOR_KEY, UTILITY_LOAD_CALCULATOR_URL };
